"use client";

import React from "react";
import { ChatMessage as ChatMessageType } from "../hooks/useChat";
import { formatTimestamp } from "../utils/chatUtils";

interface ChatMessageProps {
  message: ChatMessageType;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.type === "user";

  return (
    <div
      className={`flex flex-col mb-3 max-w-[80%] ${
        isUser ? "items-end self-end" : "items-start self-start"
      }`}
      role={isUser ? "complementary" : "region"}
      aria-label={`${isUser ? "User" : "Bot"} message`}
    >
      <div
        className={`rounded-2xl px-4 py-2 ${
          isUser ? "bg-blue-500 text-white" : "bg-gray-100 text-gray-800"
        }`}
      >
        {message.html ? (
          <div
            dangerouslySetInnerHTML={{ __html: message.text }}
            aria-live="polite"
          />
        ) : (
          <p>{message.text}</p>
        )}
      </div>
      <div className="text-xs text-gray-400 mt-1" aria-hidden="true">
        <time dateTime={new Date(message.timestamp).toISOString()}>
          {formatTimestamp(message.timestamp)}
        </time>
      </div>
    </div>
  );
};

export default ChatMessage;
